
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 1L1.001 12.998 12.999 1zM13 13L1 1.004 13 13z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13 1L1.001 12.998M12.999 13L1 1.004","stroke":"#C5C5C5","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    